const start=()=>{void import("./lib/monitoring/browser").then(module=>module.installCapture()).catch(()=>{});};
if(typeof requestIdleCallback==="function") requestIdleCallback(start,{timeout:2000}); else setTimeout(start,0);
